import { Sparkles } from "lucide-react";
import { Card } from "~/components/ui/card";
import { Badge } from "~/components/ui/badge";
import { Particles } from "~/components/particles";
import { GetStartedButton } from "./get-started-button";
import { useEffect, useRef } from "react";
import { Rocket, Wifi, User } from "lucide-react";

export function Hero() {
  const imageRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!imageRef.current) return;
      const scrollY = window.scrollY;
      const translateY = Math.min(scrollY * 0.2, 200);
      imageRef.current.style.transform = `translateY(-${translateY}px)`;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="py-20 px-4 md:px-6 lg:px-8 relative">
      <div className="container px-4 py-20 md:py-32">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16">
          <div className="flex flex-col justify-center">
            <Badge className="w-fit gap-2 mb-8 rounded-full px-4 py-1 text-sm">
              <Sparkles className="h-4 w-4" />
              AI-Powered Learning Made Fun
            </Badge>
            <h1 className="text-5xl md:text-7xl font-bold leading-tight tracking-tighter mb-8">
              AI-Powered Interactive Learning for your classroom
            </h1>
            <p className="text-xl text-gray-600 mb-8">
              Transform any topic into interactive worksheets that students
              love. Perfect for teachers, homeschoolers, and learners of all
              ages.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <GetStartedButton size="lg" />
            </div>
          </div>

          <div className="relative hidden lg:block">
            <div className="relative max-w-[400px] ml-auto m-8">
              <Card className="absolute border-2 -bottom-6 -right-6 w-full h-full bg-red-300 rounded-3xl" />
              <Card className="absolute border-2 -bottom-3 -right-3 w-full h-full bg-orange-300 rounded-3xl" />

              <Card className="relative border-2 bg-violet-200 w-full h-full rounded-3xl p-6">
                <div className="absolute z-40 -top-6 -left-20 flex flex-col items-start gap-4">
                  <Badge className="text-xl bg-yellow-300 text-yellow-900 transform rotate-6">
                    <Rocket className="w-4 h-4 mr-1" />
                    Engaging
                  </Badge>
                  <Badge className="text-xl bg-blue-300 text-blue-900 ">
                    <Wifi className="w-4 h-4 mr-1" />
                    Interactive
                  </Badge>
                  <Badge className="text-xl bg-orange-300 text-orange-900 transform -rotate-6">
                    <User className="w-4 h-4 mr-1" />
                    Personalised
                  </Badge>
                </div>

                <div className="relative max-h-[500px] overflow-hidden">
                  <img
                    alt="AI Worksheet Preview"
                    src="/battlecards.png"
                    ref={imageRef}
                    className="w-full object-cover transition-transform duration-200"
                    style={{ transform: "translateY(0)" }}
                  />
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>

      <Particles
        className="absolute inset-0 z-0"
        quantity={100}
        ease={80}
        color={"red"}
        refresh
      />
    </section>
  );
}
